
    <div #valueContainer>{{ value }}</div>
  